module.exports = __webpack_public_path__ + "img/nav-pauses.56721b26.svg";